import { URLS } from '@/data';

export const addResizeParamToURL = (url: string, size: number): string => {
    const encodedUrl = encodeURIComponent(url);
    return `${URLS.BETR_CDN_URL}/image/width=${size}/${encodedUrl}`;
};
